// This file is auto-generated by @hey-api/openapi-ts

export type Error = {
    message?: string;
    messageKey?: string;
    messageParams: Array<{
        [key: string]: unknown;
    }>;
};

export type ErrorResponse = {
    messageKey?: string;
    globalErrors: Array<Error>;
    fieldErrors: Array<FieldErrors>;
};

export type FieldErrors = {
    path: string;
    errors: Array<Error>;
};

export enum FirmwareConfigState {
    PUBLIC = 'PUBLIC',
    RESTRICTED = 'RESTRICTED',
    DISABLED = 'DISABLED'
}

export type FirmwareConfigUpdateRequest = {
    semanticVersion: string;
    active?: boolean;
    state?: FirmwareConfigState;
    fileContent?: string;
    filename?: string;
    /**
     * Only respected if firmware to update is of type application
     */
    implicitModemFirmwareConfigId?: string;
    /**
     * Only respected if firmware to update is of type modem
     */
    previousModemFirmwareConfigId?: string;
};

export type FirmwareConfigDetailResponse = {
    id: string;
    semanticVersion: string;
    name: string;
    displayName: string;
    active: boolean;
    state: FirmwareConfigState;
    tenantId: string;
    filename?: string;
    type: string;
    implicitModemFirmwareConfig?: FirmwareConfigResponse;
    previousModemFirmwareConfig?: FirmwareConfigResponse;
};

export type FirmwareConfigResponse = {
    id: string;
    semanticVersion: string;
    name: string;
    displayName: string;
    tenantId: string;
    type: string;
    state: FirmwareConfigState;
};

export enum CellularPriorityMode {
    NB_IOT = 'NB_IOT',
    LTE_M = 'LTE_M'
}

export type UpdateCellularPriorityRequest = {
    cellularPriorityMode: CellularPriorityMode;
    filterKeyword?: string;
    filterLabels?: Array<(string)>;
    comModuleIds?: Array<(string)>;
};

export type CustomTariffRequest = {
    name: string;
    sendInterval: Interval;
    readInterval: Interval;
    maxRegisterPerDevice: number;
    tokensPerDay: number;
    invoiceIdentifier?: string;
};

export enum Interval {
    NEVER = 'NEVER',
    ONE_SECOND = 'ONE_SECOND',
    TWO_SECONDS = 'TWO_SECONDS',
    FIVE_SECONDS = 'FIVE_SECONDS',
    TEN_SECONDS = 'TEN_SECONDS',
    FIFTEEN_SECONDS = 'FIFTEEN_SECONDS',
    TWENTY_SECONDS = 'TWENTY_SECONDS',
    THIRTY_SECONDS = 'THIRTY_SECONDS',
    FORTY_FIVE_SECONDS = 'FORTY_FIVE_SECONDS',
    ONE_MINUTE = 'ONE_MINUTE',
    TWO_MINUTES = 'TWO_MINUTES',
    FIVE_MINUTES = 'FIVE_MINUTES',
    TEN_MINUTES = 'TEN_MINUTES',
    FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
    TWENTY_MINUTES = 'TWENTY_MINUTES',
    THIRTY_MINUTES = 'THIRTY_MINUTES',
    FORTY_FIVE_MINUTES = 'FORTY_FIVE_MINUTES',
    ONE_HOUR = 'ONE_HOUR',
    TWO_HOURS = 'TWO_HOURS',
    FIVE_HOURS = 'FIVE_HOURS',
    TEN_HOURS = 'TEN_HOURS',
    TWELVE_HOURS = 'TWELVE_HOURS',
    EIGHTEEN_HOURS = 'EIGHTEEN_HOURS',
    ONE_DAY = 'ONE_DAY',
    TWO_DAYS = 'TWO_DAYS',
    THREE_DAYS = 'THREE_DAYS',
    FOUR_DAYS = 'FOUR_DAYS',
    FIVE_DAYS = 'FIVE_DAYS',
    SIX_DAYS = 'SIX_DAYS',
    ONE_WEEK = 'ONE_WEEK',
    TWO_WEEKS = 'TWO_WEEKS',
    FOUR_WEEKS = 'FOUR_WEEKS'
}

export type TariffResponse = {
    id: string;
    tenantId?: string;
    name: string;
    sendInterval: Interval;
    readInterval: Interval;
    maxRegisterPerDevice: number;
    tokensPerDay: number;
    invoiceIdentifier?: string;
    type: TariffType;
};

export enum TariffType {
    GENERIC = 'GENERIC',
    CUSTOM = 'CUSTOM'
}

export type CustomSystemField = {
    /**
     * Name of a custom System Field
     */
    name: string;
    /**
     * Value of a custom System Field
     */
    value: string;
};

export type SystemLabelRequest = {
    id?: string;
    name?: string;
    description?: string;
};

export type UpdateSystemRequest = {
    name: string;
    description?: string;
    comModuleId?: string;
    systemTypeId?: string;
    customFields: Array<CustomSystemField>;
    labels: Array<SystemLabelRequest>;
};

export type CloudAdapterConfigResponse = {
    id: string;
    name?: string;
    type: CloudAdapterConfigType;
    send: boolean;
    receive: boolean;
    host?: string;
    sendErrors: boolean;
};

export enum CloudAdapterConfigType {
    HTTP = 'Http',
    MQTT = 'Mqtt'
}

export type ComModuleClaimingInformationResponse = {
    claimDate: string;
    displayName: string;
    userType: UserType;
    active: boolean;
};

export type ComModuleFirmwareVersionResponse = {
    currentApplication?: string;
    currentModem?: string;
    desiredApplication?: string;
    desiredModem?: string;
    currentApplicationDisplayName?: string;
    currentModemDisplayName?: string;
    desiredApplicationDisplayName?: string;
    desiredModemDisplayName?: string;
};

export type ComModuleResponse = {
    id: string;
    iccid: string;
    hardwareVariant: HardwareVariant;
    enabledProtocols: EnabledProtocols;
    tcpCapable: boolean;
    description?: string;
    firmwareVersions: ComModuleFirmwareVersionResponse;
    status: string;
    claimingInformation?: ComModuleClaimingInformationResponse;
    customerId?: string;
    assetId?: string;
    asset?: string;
    lastOnline?: string;
    lastMessageReceived?: string;
    usedBy?: ComModuleUsedByResponse;
    radioSignalStrength?: number;
    cellularPriorityMode: CellularPriorityMode;
    apiLevel?: number;
    tariff?: TariffResponse;
    labels: Array<LabelResponse>;
};

export type ComModuleUsedByResponse = {
    system?: UsedSystemResponse;
    assetDataPoints: Array<(string)>;
    asset?: UsedSystemResponse;
};

export enum EnabledProtocols {
    RTU = 'RTU',
    TCP = 'TCP',
    RTU_TCP = 'RTU_TCP'
}

export enum HardwareVariant {
    MOC_GW1 = 'MOC_GW1',
    MOC_GW2 = 'MOC_GW2'
}

export type LabelResponse = {
    id: string;
    name: string;
    description?: string;
};

export enum Parity {
    NONE = 'NONE',
    ODD = 'ODD',
    EVEN = 'EVEN'
}

export enum State {
    PROVISIONED = 'PROVISIONED',
    UNPROVISIONED = 'UNPROVISIONED',
    UNCONFIGURED = 'UNCONFIGURED',
    EMPTY = 'EMPTY'
}

export enum StopBits {
    ONE = 'ONE',
    TWO = 'TWO'
}

export type SystemResponse = {
    id: string;
    name: string;
    description?: string;
    provisioningState: State;
    comModule?: ComModuleResponse;
    systemType?: SystemTypeResponse;
    customFields: Array<CustomSystemField>;
    labels: Array<LabelResponse>;
    cloudAdapters?: Array<CloudAdapterConfigResponse>;
    state: State;
    assetProfile?: SystemTypeResponse;
};

export type SystemTypeResponse = {
    id: string;
    name: string;
    description?: string;
    baudrate: number;
    parity: Parity;
    stopBits: StopBits;
    customFields: Array<(string)>;
    tariff: TariffResponse;
};

export type UsedSystemResponse = {
    systemId: string;
    systemName: string;
    assetId: string;
    assetName: string;
};

export enum UserType {
    GLOBAL_ADMIN = 'GlobalAdmin',
    TENANT = 'Tenant',
    CUSTOMER = 'Customer',
    TOKEN = 'Token'
}

export type BulkEditLabelsRequest = {
    systemIds?: Array<(string)>;
    filterKeyword?: string;
    filterLabels?: Array<(string)>;
    labelsToAdd: Array<SystemLabelRequest>;
    labelsToDelete: Array<(string)>;
};

export type Unit = {
    [key: string]: unknown;
};

export type RTUDeviceRequest = {
    deviceTypeId: string;
    address: number;
};

export type SystemTypeRequest = {
    name: string;
    description?: string;
    rtuEnabled: boolean;
    tcpEnabled: boolean;
    baudrate: number;
    parity: Parity;
    stopBits: StopBits;
    devices: Array<RTUDeviceRequest>;
    tcpDevices: Array<TCPDeviceRequest>;
    customFields: Array<(string)>;
    /**
     * If true then ipAddress and subnetMask are not required
     */
    dhcp?: boolean;
    ipAddress?: string;
    subnetMask?: number;
};

export type TCPDeviceRequest = {
    deviceTypeId: string;
    ipAddress: string;
    port: number;
    unitId: number;
};

export enum DataType {
    RAW = 'RAW',
    INT16 = 'INT16',
    UINT16 = 'UINT16',
    INT16_LE = 'INT16_LE',
    UINT16_LE = 'UINT16_LE',
    INT32 = 'INT32',
    UINT32 = 'UINT32',
    INT32_LE = 'INT32_LE',
    UINT32_LE = 'UINT32_LE',
    INT32_ME = 'INT32_ME',
    UINT32_ME = 'UINT32_ME',
    INT64 = 'INT64',
    UINT64 = 'UINT64',
    INT64_LE = 'INT64_LE',
    UINT64_LE = 'UINT64_LE',
    INT64_ME = 'INT64_ME',
    UINT64_ME = 'UINT64_ME',
    FLOAT32 = 'FLOAT32',
    FLOAT64 = 'FLOAT64',
    UINT8 = 'UINT8'
}

export type DeviceTypeDetail = {
    id: string;
    name: string;
    description?: string;
    modbusRegisters: Array<ModbusRegisterDto>;
};

export type ModbusRegisterDto = {
    id: string;
    name?: string;
    details?: string;
    startingAddress?: number;
    quantity?: number;
    functionCode?: number;
    dataType?: DataType;
    readInterval?: Interval;
    sendInterval?: Interval;
    alertInterval?: Interval;
    lowThreshold?: number;
    highThreshold?: number;
    sendOnChange?: boolean;
    hysteresis?: number;
};

export type RTUDeviceDetail = {
    deviceTypeId: string;
    address: number;
    deviceProfileId: string;
};

export type SystemTypeDetailResponse = {
    id: string;
    name: string;
    description?: string;
    rtuEnabled: boolean;
    tcpEnabled: boolean;
    baudrate: number;
    parity: Parity;
    stopBits: StopBits;
    dhcp: boolean;
    ipAddress?: string;
    subnetMask?: number;
    associatedComModulesEnabledProtocol?: EnabledProtocols;
    devices: Array<RTUDeviceDetail>;
    tcpDevices: Array<TCPDeviceDetail>;
    deviceTypes: Array<DeviceTypeDetail>;
    usedBy: Array<UsedSystemResponse>;
    customFields: Array<(string)>;
    tariff: TariffResponse;
    customerDevices: Array<RTUDeviceDetail>;
    deviceProfiles: Array<DeviceTypeDetail>;
};

export type TCPDeviceDetail = {
    deviceTypeId: string;
    ipAddress: string;
    port: number;
    unitId: number;
    deviceProfileId: string;
};

export type LabelRequest = {
    name: string;
    description?: string;
};

export type DeviceTypeRequest = {
    name: string;
    description?: string;
    modbusRegisters: Array<ModbusRegisterRequest>;
    synchronousReadout?: boolean;
};

export type ModbusRegisterRequest = {
    name: string;
    details?: string;
    startingAddress: number;
    quantity: number;
    functionCode: number;
    dataType: DataType;
    readInterval: Interval;
    sendInterval: Interval;
    alertInterval: Interval;
    lowThreshold?: number;
    highThreshold?: number;
    sendOnChange: boolean;
    hysteresis?: number;
};

export type DeviceTypeResponse = {
    id: string;
    name: string;
    description?: string;
    modbusRegisters: Array<ModbusRegisterResponse>;
    usedBy: Array<UsedSystemTypeResponse>;
    synchronousReadout: boolean;
    tariff: TariffResponse;
};

export type ModbusRegisterResponse = {
    id: string;
    name: string;
    details?: string;
    startingAddress: number;
    quantity: number;
    functionCode: number;
    dataType: DataType;
    readInterval: Interval;
    sendInterval: Interval;
    alertInterval?: Interval;
    lowThreshold?: number;
    highThreshold?: number;
    sendOnChange: boolean;
    hysteresis?: number;
    usedBy: Array<(string)>;
};

export type UsedSystemTypeResponse = {
    systemTypeId: string;
    systemTypeName: string;
    systemProfileId: string;
    systemProfileName: string;
};

export enum GW2SupportedProtocols {
    TCP = 'TCP',
    RTU_TCP = 'RTU_TCP'
}

export type UpdateEnabledProtocolRequest = {
    enabledProtocol: GW2SupportedProtocols;
};

export type DesiredFirmwareVersionRequest = {
    firmwareConfigId: string;
    filterKeyword?: string;
    filterLabels?: Array<(string)>;
    comModuleIds?: Array<(string)>;
};

export enum CloudAdapterSupportedHttpVerb {
    PATCH = 'PATCH',
    POST = 'POST',
    PUT = 'PUT'
}

export type HeaderField = {
    name: string;
    value: string;
};

/**
 * The field type must be of either HTTP or MQTT
 */
export type UpdateCloudAdapterConfigRequest = {
    password?: string;
    name?: string;
    labels: Array<(string)>;
    send: boolean;
    sendBatched: boolean;
    username?: string;
    sendErrors: boolean;
    receive: boolean;
    payloadTemplate: string;
    type: string;
};

export type UpdateHttpCloudAdapterConfigRequest = UpdateCloudAdapterConfigRequest & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate?: string;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional
     */
    url?: string;
    verb?: CloudAdapterSupportedHttpVerb;
    headers?: Array<HeaderField>;
    tokens?: Array<UpdateTokenUserRequest>;
    errorUrl?: string;
    errorHeaders?: Array<HeaderField>;
    errorUsername?: string;
    errorPassword?: string;
    errorVerb?: CloudAdapterSupportedHttpVerb;
} & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate: string;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional
     */
    url: string;
    verb: CloudAdapterSupportedHttpVerb;
    headers: Array<HeaderField>;
    tokens: Array<UpdateTokenUserRequest>;
    errorHeaders: Array<HeaderField>;
};

export type UpdateMqttCloudAdapterConfigRequest = UpdateCloudAdapterConfigRequest & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate?: string;
    username?: string;
    password?: string;
    host?: string;
    port?: number;
    publishingTopicTemplate?: string;
    clientId?: string;
    /**
     * Must be Base64 encoded.
     */
    certificateCa?: string;
    certificateCaFilename?: string;
    /**
     * Must be Base64 encoded.
     */
    clientCertificate?: string;
    clientCertificateFilename?: string;
    /**
     * Must be Base64 encoded.
     */
    clientKey?: string;
    clientKeyFilename?: string;
    /**
     * The topic to publish error messages on. Must not be null if `sendErrors` is set to true. Must not contain any wildcard characters. Must be a valid Handlebars template. It may only contain fields that are invariant for different messages when using batched sending.
     */
    errorTopic?: string;
} & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate: string;
    host: string;
    port: number;
};

export type UpdateTokenUserRequest = {
    id?: string;
    name: string;
    roleId?: string;
    scopeIds?: Array<(string)>;
};

export type ApiKeyResponse = {
    id: string;
    name: string;
    apiKey: string;
    role: RoleResponse;
    scopes: Array<ScopeResponse>;
    type: UserType;
    customerId?: string;
};

export type CloudAdapterConfigDetailResponse = {
    password?: string;
    name?: string;
    id: string;
    host?: string;
    labels: Array<LabelResponse>;
    send: boolean;
    sendBatched: boolean;
    username?: string;
    sendErrors: boolean;
    receive: boolean;
    customerId: string;
    payloadTemplate: string;
    type: string;
};

export type HttpCloudAdapterConfigDetailResponse = CloudAdapterConfigDetailResponse & {
    url?: string;
    verb?: CloudAdapterSupportedHttpVerb;
    headers?: Array<HeaderField>;
    tokens?: Array<ApiKeyResponse>;
    errorUrl?: string;
    errorHeaders?: Array<HeaderField>;
    errorUsername?: string;
    errorPassword?: string;
    errorVerb?: CloudAdapterSupportedHttpVerb;
} & {
    url: string;
    verb: CloudAdapterSupportedHttpVerb;
    headers: Array<HeaderField>;
    tokens: Array<ApiKeyResponse>;
    errorHeaders: Array<HeaderField>;
};

export type MqttCloudAdapterConfigDetailResponse = CloudAdapterConfigDetailResponse & {
    port?: number;
    publishingTopicTemplate?: string;
    clientId?: string;
    certificateCa?: string;
    certificateCaFilename?: string;
    certificateCaValidity?: string;
    clientCertificate?: string;
    clientCertificateFilename?: string;
    clientCertificateValidity?: string;
    clientKeyFilename?: string;
    errorTopic?: string;
} & {
    port: number;
};

export type RoleResponse = {
    id: string;
    name: string;
    level: number;
    scopes: Array<(string)>;
};

export type ScopeResponse = {
    id: string;
    name: string;
    availableOnCustomer: boolean;
};

export type UpdateCellularPriorityCommandRequest = {
    comModuleId: string;
    iccid?: string;
    cellularPriorityMode: CellularPriorityMode;
    correlationID?: string;
};

export type CommandRequestDataResponse = {
    id: string;
    value?: {
        [key: string]: unknown;
    };
    status: CommandRequestStatus;
    correlationID?: string;
    error?: ModuleErrorResponse;
};

export enum CommandRequestStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    TIMEOUT = 'TIMEOUT'
}

export enum DeviceMessageType {
    GENERIC_ERROR = 'GENERIC_ERROR',
    MODBUS_CONFIG = 'MODBUS_CONFIG',
    DATA_CONFIG_ENTRY_UPDATE = 'DATA_CONFIG_ENTRY_UPDATE',
    DATA_CONFIG_ENTRY_REMOVE = 'DATA_CONFIG_ENTRY_REMOVE',
    DATA_CONFIG_RESET = 'DATA_CONFIG_RESET',
    DATA_CONFIG_HASH = 'DATA_CONFIG_HASH',
    SINGLE_READ = 'SINGLE_READ',
    SINGLE_WRITE = 'SINGLE_WRITE',
    DATA_MESSAGE_ERROR = 'DATA_MESSAGE_ERROR',
    DEVICE_REBOOT = 'DEVICE_REBOOT',
    TOKEN_PER_DAY = 'TOKEN_PER_DAY',
    DISCARDED_MESSAGE_COUNTER = 'DISCARDED_MESSAGE_COUNTER'
}

export type ModuleErrorResponse = {
    comModuleId: string;
    responseId: number;
    responseType: DeviceMessageType;
    statusCode: number;
    created: string;
};

export type DesiredFirmwareRequest = {
    firmwareConfigId: string;
};

export type FirmwareInformationResponse = {
    status: FirmwareUpdateState;
    comModuleId: string;
};

export enum FirmwareUpdateState {
    IDLE = 'IDLE',
    DOWNLOADING = 'DOWNLOADING',
    DOWNLOADED = 'DOWNLOADED',
    UPDATING = 'UPDATING'
}

export type StartFirmwareDownloadRequestV2 = {
    firmwareConfigId: string;
};

export type CreateUserRequest = {
    email: string;
    name: string;
    type: UserType;
    tenantOrCustomerId: string;
    roleId: string;
    /**
     * Must be a language code of ISO 639-1
     */
    language?: string;
    /**
     * Must be either 'dd.MM.yyyy' or 'MM/dd/yyyy'
     */
    dateFormat?: string;
    /**
     * Must be a combination of language code of ISO 639-1 and country code of ISO 3166-1 seperated by an underscore
     */
    locale?: string;
    mfaEnforced?: boolean;
};

export type IdentityProviderInfo = {
    createdAt: string;
    loginCount: number;
    lastLogin?: string;
    lastPasswordReset?: string;
    emailVerified: boolean;
    lastIp?: string;
};

export type UserResponse = {
    id: string;
    tokenSubject?: string;
    email: string;
    name: string;
    role: RoleResponse;
    type: UserType;
    tenantId?: string;
    customerId?: string;
    identityProviderInfo?: IdentityProviderInfo;
    language?: string;
    dateFormat?: string;
    locale?: string;
    active: boolean;
    hasClaimedDevices: boolean;
    mfaEnforced: boolean;
};

export type ApplicationFirmwareConfigCreateRequest = FirmwareConfigCreateRequest & {
    semanticVersion?: string;
    fileContent?: string;
    filename?: string;
    implicitModemFirmwareConfigId?: string;
    type?: 'application';
} & {
    semanticVersion: string;
    fileContent: string;
    filename: string;
};

export enum type {
    APPLICATION = 'application'
}

export type FirmwareConfigCreateRequest = {
    semanticVersion: string;
    active?: boolean;
    state?: FirmwareConfigState;
    fileContent: string;
    filename: string;
    type: string;
};

export type ModemFirmwareConfigCreateRequest = FirmwareConfigCreateRequest & {
    semanticVersion?: string;
    fileContent?: string;
    filename?: string;
    previousModemFirmwareConfigId?: string;
    type?: 'modem';
} & {
    semanticVersion: string;
    fileContent: string;
    filename: string;
};

export enum type2 {
    MODEM = 'modem'
}

export type CreateCustomerRequest = {
    name: string;
    customId: string;
    address: CustomerAddress;
    billingDetails: CustomerBillingDetails;
    initialAdmin?: InitialAdmin;
    /**
     * Must be a language code of ISO 639-1
     */
    defaultLanguage?: string;
    tariffId?: string;
    tariffs?: Array<TariffAndRank>;
    externalApiEnabled?: boolean;
    dataConsumptionViewEnabled?: boolean;
    tcpEnabled?: boolean;
    friendly?: boolean;
    timeSynchronousReadoutEnabled?: boolean;
    cloudAdapterLimit?: number;
    experimentalUiFeaturesEnabled?: boolean;
    auditLogEnabled?: boolean;
    mfaEnforced?: boolean;
    advancedCloudAdapterTemplateEnabled?: boolean;
};

export type CustomerAddress = {
    streetName?: string;
    streetNumber?: string;
    postalCode?: string;
    city?: string;
    country?: string;
};

export type CustomerBillingDetails = {
    contactName: string;
    contactEmail: string;
    taxId?: string;
};

export type InitialAdmin = {
    name: string;
    email: string;
    /**
     * Must be a language code of ISO 639-1
     */
    language?: string;
    /**
     * Must be either 'dd.MM.yyyy' or 'MM/dd/yyyy'
     */
    dateFormat?: string;
    /**
     * Must be a combination of language code of ISO 639-1 and country code of ISO 3166-1 seperated by an underscore
     */
    locale?: string;
};

export type TariffAndRank = {
    tariffId: string;
    /**
     * Rank should start at 0 and be in sequential order. Lowest rank is represented by 0
     */
    rank: number;
};

export type CustomerDetailResponse = {
    id: string;
    name: string;
    customId?: string;
    address?: CustomerAddress;
    billingDetails: CustomerBillingDetails;
    isActive: boolean;
    desiredFirmwareConfigId?: string;
    defaultLanguage?: string;
    tariff: TariffResponse;
    tariffs?: Array<CustomerTariffResponse>;
    externalApiEnabled: boolean;
    dataConsumptionViewEnabled: boolean;
    tcpEnabled: boolean;
    friendly: boolean;
    cloudAdapterLimit: number;
    cloudAdapterCounter: number;
    timeSynchronousReadoutEnabled: boolean;
    experimentalUiFeaturesEnabled: boolean;
    auditLogEnabled: boolean;
    mfaEnforced: boolean;
    licenseContingent?: number;
    advancedCloudAdapterTemplateEnabled: boolean;
};

export type CustomerTariffResponse = {
    id: string;
    tenantId?: string;
    name: string;
    rank: number;
    sendInterval: Interval;
    readInterval: Interval;
    maxRegisterPerDevice: number;
    type: TariffType;
    tokensPerDay: number;
};

export type CreateSystemRequest = {
    name: string;
    description?: string;
    comModuleId?: string;
    systemTypeId?: string;
    customFields: Array<CustomSystemField>;
    labels: Array<SystemLabelRequest>;
};

/**
 * The field type must be of either HTTP or MQTT
 */
export type CreateCloudAdapterConfigRequest = {
    password?: string;
    name?: string;
    labels: Array<(string)>;
    send: boolean;
    sendBatched: boolean;
    username?: string;
    sendErrors: boolean;
    receive: boolean;
    payloadTemplate: string;
    type: string;
};

export type CreateHttpCloudAdapterConfigRequest = CreateCloudAdapterConfigRequest & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate?: string;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional
     */
    url?: string;
    verb?: CloudAdapterSupportedHttpVerb;
    headers?: Array<HeaderField>;
    tokens?: Array<CreateTokenUserRequest>;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional. Can be null if sendErrors is false
     */
    errorUrl?: string;
    errorHeaders?: Array<HeaderField>;
    errorUsername?: string;
    errorPassword?: string;
    errorVerb?: CloudAdapterSupportedHttpVerb;
} & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate: string;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional
     */
    url: string;
    verb: CloudAdapterSupportedHttpVerb;
    headers: Array<HeaderField>;
    tokens: Array<CreateTokenUserRequest>;
    /**
     * URL of format https://<host>:<port>/<path>?<query_parameters> with port and query_parameters being optional. Can be null if sendErrors is false
     */
    errorUrl: string;
    errorHeaders: Array<HeaderField>;
};

export type CreateMqttCloudAdapterConfigRequest = CreateCloudAdapterConfigRequest & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate?: string;
    username?: string;
    password?: string;
    host?: string;
    port?: number;
    publishingTopicTemplate?: string;
    clientId?: string;
    /**
     * Must be Base64 encoded.
     */
    certificateCa?: string;
    certificateCaFilename?: string;
    /**
     * Must be Base64 encoded.
     */
    clientCertificate?: string;
    clientCertificateFilename?: string;
    /**
     * Must be Base64 encoded.
     */
    clientKey?: string;
    clientKeyFilename?: string;
    /**
     * The topic to publish error messages on. Must not be null if `sendErrors` is set to true. Must not contain any wildcard characters. Must be a valid Handlebars template. It may only contain fields that are invariant for different messages when using batched sending.
     */
    errorTopic?: string;
} & {
    /**
     * Must be Base64 encoded.
     */
    payloadTemplate: string;
    host: string;
    port: number;
};

export type CreateTokenUserRequest = {
    name: string;
    roleId?: string;
    scopeIds?: Array<(string)>;
};

export enum TestRunResult {
    SUCCESS = 'SUCCESS',
    UNKNOWN_FAILURE = 'UNKNOWN_FAILURE',
    CLIENT_EXCEPTION = 'CLIENT_EXCEPTION',
    INVALID_PROTOCOL_VERSION = 'INVALID_PROTOCOL_VERSION',
    INVALID_CLIENT_ID = 'INVALID_CLIENT_ID',
    BROKER_UNAVAILABLE = 'BROKER_UNAVAILABLE',
    FAILED_AUTHENTICATION = 'FAILED_AUTHENTICATION',
    NOT_AUTHORIZED = 'NOT_AUTHORIZED',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    SUBSCRIBE_FAILED = 'SUBSCRIBE_FAILED',
    CLIENT_TIMEOUT = 'CLIENT_TIMEOUT',
    SERVER_CONNECT_ERROR = 'SERVER_CONNECT_ERROR',
    SSL_CONFIG_ERROR = 'SSL_CONFIG_ERROR',
    CONNECTION_LOST = 'CONNECTION_LOST'
}

export type TestRunResultResponse = {
    result: TestRunResult;
};

export type SingleWriteRequest = {
    comModuleId?: string;
    iccid?: string;
    deviceAddress?: number;
    ipAddress?: string;
    port?: number;
    unitId?: number;
    startAddress: number;
    functionCode: number;
    quantity?: number;
    dataType: DataType;
    value: {
        [key: string]: unknown;
    };
    correlationID?: string;
};

export type RebootRequest = {
    comModuleId?: string;
    iccid?: string;
    correlationID?: string;
};

export type SingleReadRequest = {
    comModuleId?: string;
    iccid?: string;
    deviceAddress?: number;
    ipAddress?: string;
    port?: number;
    unitId?: number;
    startAddress: number;
    functionCode: number;
    quantity: number;
    dataType: DataType;
    correlationID?: string;
    /**
     * When set to true, the specified readout must match a configured register on the ComModule. The readout value will then also be sent over the configured cloud adapters
     */
    useCloudAdapters: (boolean) | null;
};

export type CreateClaimRequest = {
    customerId: string;
    iccid: string;
    description?: string;
    secretTag: string;
};

export type UpdateUserRequest = {
    name?: string;
    roleId?: string;
    /**
     * Must be a language code of ISO 639-1
     */
    language?: string;
    /**
     * Must be either 'dd.MM.yyyy' or 'MM/dd/yyyy'
     */
    dateFormat?: string;
    active?: boolean;
    /**
     * Must be a combination of language code of ISO 639-1 and country code of ISO 3166-1 seperated by an underscore
     */
    locale?: string;
    mfaEnforced?: boolean,
};

export type UpdateCustomerRequest = {
    name?: string;
    customId?: string;
    address?: CustomerAddress;
    billingDetails?: CustomerBillingDetails;
    isActive?: boolean;
    /**
     * Must be a language code of ISO 639-1
     */
    defaultLanguage?: string;
    tariffId?: string;
    tariffs?: Array<TariffAndRank>;
    externalApiEnabled?: boolean;
    dataConsumptionViewEnabled?: boolean;
    tcpEnabled?: boolean;
    friendly?: boolean;
    timeSynchronousReadoutEnabled?: boolean;
    cloudAdapterLimit?: number;
    experimentalUiFeaturesEnabled?: boolean;
    auditLogEnabled?: boolean;
    advancedCloudAdapterTemplateEnabled?: boolean;
};

export type UpdateComModuleRequest = {
    description?: string;
};

export type PageTenantResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<TenantResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageableObject = {
    offset?: number;
    sort?: Array<SortObject>;
    paged?: boolean;
    pageNumber?: number;
    pageSize?: number;
    unpaged?: boolean;
};

export type SortObject = {
    direction?: string;
    nullHandling?: string;
    ascending?: boolean;
    property?: string;
    ignoreCase?: boolean;
};

export type TenantResponse = {
    id: string;
    name: string;
};

export type PageUserListResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<UserListResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type UserListResponse = {
    id: string;
    tokenSubject?: string;
    email: string;
    name: string;
    active: boolean;
    role: UserListResponseRole;
};

export type UserListResponseRole = {
    id: string;
    name: string;
};

export type PageFirmwareConfigDetailResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<FirmwareConfigDetailResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageFirmwareConfigResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<FirmwareConfigResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type CustomerResponse = {
    id: string;
    name: string;
    billingContactName: string;
    billingContactEmail: string;
    isActive: boolean;
};

export type PageCustomerResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<CustomerResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageTariffResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<TariffResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageReadoutErrorResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<ReadoutErrorResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type ReadoutErrorResponse = {
    comModuleId: string;
    errorCode: number;
    receivedTimestamp: string;
    deviceTypeName?: string;
    registerName?: string;
    deviceAddress?: number;
    ipAddress?: string;
    port?: number;
    unitId?: number;
    startAddress?: number;
    functionCode?: number;
    dataType?: DataType;
    quantity?: number;
};

export type TemplateVariableCollection = {
    standardVariables: Array<TemplateVariableResponse>;
};

export type TemplateVariableResponse = {
    name: string;
    types: Array<(string)>;
    description: string;
    isBodyOnly: boolean;
    variableOrigin: VariableOrigin;
};

export enum VariableOrigin {
    SYSTEM = 'SYSTEM',
    SYSTEM_TYPE = 'SYSTEM_TYPE',
    DEVICE_TYPE = 'DEVICE_TYPE',
    REGISTER = 'REGISTER',
    UNKNOWN = 'UNKNOWN'
}

export type PageSystemResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<SystemResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageSystemTypeDetailResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<SystemTypeDetailResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageLabelResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<LabelResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type DeviceTypeListResponse = {
    id: string;
    name: string;
    description?: string;
    modbusRegisters: Array<(string)>;
    synchronousReadout: boolean;
    tariff: TariffResponse;
};

export type PageDeviceTypeListResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<DeviceTypeListResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type Pageable = {
    page?: number;
    size?: number;
    sort?: Array<(string)>;
};

export type PageComModuleResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<ComModuleResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type SseEmitter = {
    timeout?: number;
};

export type PageCloudAdapterConfigResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<CloudAdapterConfigResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type AuditEntryResponse = {
    id: string;
    actionTimestamp?: string;
    transactionId: number;
    userId?: string;
    userName?: string;
    userEmail?: string;
    customerId?: string;
    actionType: string;
    entityTypeName: string;
    entityId: string;
    entityOldData?: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    entityNewData?: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    changedConfidentialFields?: Array<(string)>;
};

export type PageAuditEntryResponse = {
    totalPages?: number;
    totalElements?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
    content?: Array<AuditEntryResponse>;
    number?: number;
    sort?: Array<SortObject>;
    pageable?: PageableObject;
    numberOfElements?: number;
    empty?: boolean;
};

export type GetFirmwareConfigByIdData = {
    path: {
        firmwareConfigId: string;
        tenantId: string;
    };
};

export type GetFirmwareConfigByIdResponse = (FirmwareConfigDetailResponse);

export type GetFirmwareConfigByIdError = (ErrorResponse);

export type UpdateFirmwareConfigByIdData = {
    body: FirmwareConfigUpdateRequest;
    path: {
        firmwareConfigId: string;
        tenantId: string;
    };
};

export type UpdateFirmwareConfigByIdResponse = (FirmwareConfigDetailResponse);

export type UpdateFirmwareConfigByIdError = (ErrorResponse);

export type DeleteFirmwareConfigByIdData = {
    path: {
        firmwareConfigId: string;
        tenantId: string;
    };
};

export type DeleteFirmwareConfigByIdResponse = (void);

export type DeleteFirmwareConfigByIdError = (ErrorResponse);

export type DeprecatedUpdateFirmwareConfigByIdData = {
    body: FirmwareConfigUpdateRequest;
    path: {
        firmwareConfigId: string;
        tenantId: string;
    };
};

export type DeprecatedUpdateFirmwareConfigByIdResponse = (FirmwareConfigDetailResponse);

export type DeprecatedUpdateFirmwareConfigByIdError = (ErrorResponse);

export type GetAllDetailedFirmwareConfigsData = {
    path: {
        tenantId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        /**
         * Possible values are: `PUBLIC`, `RESTRICTED` or `DISABLED`
         */
        state?: unknown;
        /**
         * Possible values are: `modem` or `application`
         */
        type?: unknown;
    };
};

export type GetAllDetailedFirmwareConfigsResponse = (PageFirmwareConfigDetailResponse);

export type GetAllDetailedFirmwareConfigsError = (ErrorResponse);

export type CreateFirmwareConfigData = {
    body: (ApplicationFirmwareConfigCreateRequest | ModemFirmwareConfigCreateRequest);
    path: {
        tenantId: string;
    };
};

export type CreateFirmwareConfigResponse = (FirmwareConfigDetailResponse);

export type CreateFirmwareConfigError = (ErrorResponse);

export type GetAllActiveFirmwareConfigsData = {
    path: {
        tenantId: string;
    };
    query?: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllActiveFirmwareConfigsResponse = (PageFirmwareConfigResponse);

export type GetAllActiveFirmwareConfigsError = (ErrorResponse);

export type GetAllAvailableFirmwareConfigsData = {
    path: {
        customerId: string;
    };
    query: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        /**
         * Possible values are: `modem` or `application`
         */
        type: string;
    };
};

export type GetAllAvailableFirmwareConfigsResponse = (PageFirmwareConfigDetailResponse);

export type GetAllAvailableFirmwareConfigsError = (ErrorResponse);

export type BulkUpdateModulesData = {
    body: UpdateCellularPriorityRequest;
    path: {
        customerId: string;
        tenantId: string;
    };
};

export type BulkUpdateModulesResponse = (unknown);

export type BulkUpdateModulesError = (ErrorResponse);

export type GetTenantTariffData = {
    path: {
        tariffId: string;
        tenantId: string;
    };
};

export type GetTenantTariffResponse = (TariffResponse);

export type GetTenantTariffError = (ErrorResponse);

export type UpdateTenantTariffData = {
    body: CustomTariffRequest;
    path: {
        tariffId: string;
        tenantId: string;
    };
};

export type UpdateTenantTariffResponse = (TariffResponse);

export type UpdateTenantTariffError = (ErrorResponse);

export type DeleteTenantTariffData = {
    path: {
        tariffId: string;
        tenantId: string;
    };
};

export type DeleteTenantTariffResponse = (void);

export type DeleteTenantTariffError = (ErrorResponse);

export type GetAllTenantTariffsData = {
    path: {
        tenantId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllTenantTariffsResponse = (PageTariffResponse);

export type GetAllTenantTariffsError = (ErrorResponse);

export type CreateTenantTariffData = {
    body: CustomTariffRequest;
    path: {
        tenantId: string;
    };
};

export type CreateTenantTariffResponse = (TariffResponse);

export type CreateTenantTariffError = (ErrorResponse);

export type GetAllCustomersOfTenantTariffData = {
    path: {
        tariffId: string;
        tenantId: string;
    };
};

export type GetAllCustomersOfTenantTariffResponse = (Array<CustomerResponse>);

export type GetAllCustomersOfTenantTariffError = (ErrorResponse);

export type GetTariffData = {
    path: {
        tariffId: string;
    };
};

export type GetTariffResponse = (TariffResponse);

export type GetTariffError = (ErrorResponse);

export type UpdateTariffData = {
    body: CustomTariffRequest;
    path: {
        tariffId: string;
    };
};

export type UpdateTariffResponse = (TariffResponse);

export type UpdateTariffError = (ErrorResponse);

export type DeleteTariffData = {
    path: {
        tariffId: string;
    };
};

export type DeleteTariffResponse = (void);

export type DeleteTariffError = (ErrorResponse);

export type GetAllTariffsData = {
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllTariffsResponse = (PageTariffResponse);

export type GetAllTariffsError = (ErrorResponse);

export type CreateTariffData = {
    body: CustomTariffRequest;
};

export type CreateTariffResponse = (TariffResponse);

export type CreateTariffError = (ErrorResponse);

export type GetAllCustomersOfTariffData = {
    path: {
        tariffId: string;
    };
};

export type GetAllCustomersOfTariffResponse = (Array<CustomerResponse>);

export type GetAllCustomersOfTariffError = (ErrorResponse);

export type GetSystemByIdData = {
    path: {
        customerId: string;
        systemId: string;
    };
};

export type GetSystemByIdResponse = (SystemResponse);

export type GetSystemByIdError = (ErrorResponse);

export type UpdateSystemByIdData = {
    body: UpdateSystemRequest;
    path: {
        customerId: string;
        systemId: string;
    };
};

export type UpdateSystemByIdResponse = (SystemResponse);

export type UpdateSystemByIdError = (ErrorResponse);

export type DeleteSystemByIdData = {
    path: {
        customerId: string;
        systemId: string;
    };
};

export type DeleteSystemByIdResponse = (void);

export type DeleteSystemByIdError = (ErrorResponse);

export type BulkEditLabelsOnSystemsData = {
    body: BulkEditLabelsRequest;
    path: {
        customerId: string;
    };
};

export type BulkEditLabelsOnSystemsResponse = (Unit);

export type BulkEditLabelsOnSystemsError = (ErrorResponse);

export type GetAllSystemsData = {
    path: {
        customerId: string;
    };
    query?: {
        filter?: string;
        /**
         * match all Systems without associated labels. Only respected if true
         */
        hasNoLabel?: string;
        labels?: Array<(string)>;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        state?: State;
        systemTypeId?: string;
        tariffId?: string;
    };
};

export type GetAllSystemsResponse = (PageSystemResponse);

export type GetAllSystemsError = (ErrorResponse);

export type CreateSystemData = {
    body: CreateSystemRequest;
    path: {
        customerId: string;
    };
};

export type CreateSystemResponse = (SystemResponse);

export type CreateSystemError = (ErrorResponse);

export type GetSystemTypeByIdData = {
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type GetSystemTypeByIdResponse = (SystemTypeDetailResponse);

export type GetSystemTypeByIdError = (ErrorResponse);

export type UpdateSystemTypeByIdData = {
    body: SystemTypeRequest;
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type UpdateSystemTypeByIdResponse = (SystemTypeDetailResponse);

export type UpdateSystemTypeByIdError = (ErrorResponse);

export type DeleteSystemTypeByIdData = {
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type DeleteSystemTypeByIdResponse = (void);

export type DeleteSystemTypeByIdError = (ErrorResponse);

export type GetAllSystemTypesData = {
    path: {
        customerId: string;
    };
    query?: {
        deviceTypeId?: string;
        filter?: string;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        rtuEnabled?: boolean;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        tariffId?: string;
        tcpEnabled?: boolean;
    };
};

export type GetAllSystemTypesResponse = (PageSystemTypeDetailResponse);

export type GetAllSystemTypesError = (ErrorResponse);

export type CreateSystemTypeData = {
    body: SystemTypeRequest;
    path: {
        customerId: string;
    };
};

export type CreateSystemTypeResponse = (SystemTypeDetailResponse);

export type CreateSystemTypeError = (ErrorResponse);

export type GetLabelByIdData = {
    path: {
        customerId: string;
        labelId: string;
    };
};

export type GetLabelByIdResponse = (LabelResponse);

export type GetLabelByIdError = (ErrorResponse);

export type UpdateLabelByIdData = {
    body: LabelRequest;
    path: {
        customerId: string;
        labelId: string;
    };
};

export type UpdateLabelByIdResponse = (LabelResponse);

export type UpdateLabelByIdError = (ErrorResponse);

export type DeleteLabelByIdData = {
    path: {
        customerId: string;
        labelId: string;
    };
};

export type DeleteLabelByIdResponse = (void);

export type DeleteLabelByIdError = (ErrorResponse);

export type GetLabelsData = {
    path: {
        customerId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetLabelsResponse = (PageLabelResponse);

export type GetLabelsError = (ErrorResponse);

export type CreateLabelData = {
    body: LabelRequest;
    path: {
        customerId: string;
    };
};

export type CreateLabelResponse = (LabelResponse);

export type CreateLabelError = (ErrorResponse);

export type GetDeviceTypeByIdData = {
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type GetDeviceTypeByIdResponse = (DeviceTypeResponse);

export type GetDeviceTypeByIdError = (ErrorResponse);

export type UpdateDeviceTypeByIdData = {
    body: DeviceTypeRequest;
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type UpdateDeviceTypeByIdResponse = (DeviceTypeResponse);

export type UpdateDeviceTypeByIdError = (ErrorResponse);

export type DeleteDeviceTypeByIdData = {
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type DeleteDeviceTypeByIdResponse = (void);

export type DeleteDeviceTypeByIdError = (ErrorResponse);

export type GetAllDeviceTypesData = {
    path: {
        customerId: string;
    };
    query?: {
        filter?: string;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        tariffId?: string;
    };
};

export type GetAllDeviceTypesResponse = (PageDeviceTypeListResponse);

export type GetAllDeviceTypesError = (ErrorResponse);

export type CreateDeviceTypeData = {
    body: DeviceTypeRequest;
    path: {
        customerId: string;
    };
};

export type CreateDeviceTypeResponse = (DeviceTypeResponse);

export type CreateDeviceTypeError = (ErrorResponse);

export type GetDeviceProfileByIdData = {
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type GetDeviceProfileByIdResponse = (DeviceTypeResponse);

export type GetDeviceProfileByIdError = (ErrorResponse);

export type UpdateDeviceProfileByIdData = {
    body: DeviceTypeRequest;
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type UpdateDeviceProfileByIdResponse = (DeviceTypeResponse);

export type UpdateDeviceProfileByIdError = (ErrorResponse);

export type DeleteDeviceProfileByIdData = {
    path: {
        customerId: string;
        deviceTypeId: string;
    };
};

export type DeleteDeviceProfileByIdResponse = (void);

export type DeleteDeviceProfileByIdError = (ErrorResponse);

export type GetAllDeviceProfilesData = {
    path: {
        customerId: string;
    };
    query: {
        filter?: string;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        pageable: Pageable;
        tariffId?: string;
    };
};

export type GetAllDeviceProfilesResponse = (PageDeviceTypeListResponse);

export type GetAllDeviceProfilesError = (ErrorResponse);

export type CreateDeviceProfileData = {
    body: DeviceTypeRequest;
    path: {
        customerId: string;
    };
};

export type CreateDeviceProfileResponse = (DeviceTypeResponse);

export type CreateDeviceProfileError = (ErrorResponse);

export type UpdateComModuleEnabledProtocolData = {
    body: UpdateEnabledProtocolRequest;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type UpdateComModuleEnabledProtocolResponse = (ComModuleResponse);

export type UpdateComModuleEnabledProtocolError = (ErrorResponse);

export type GetComModuleByIdData = {
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type GetComModuleByIdResponse = (ComModuleResponse);

export type GetComModuleByIdError = (ErrorResponse);

export type UpdateComModuleByIdData = {
    body: UpdateComModuleRequest;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type UpdateComModuleByIdResponse = (ComModuleResponse);

export type UpdateComModuleByIdError = (ErrorResponse);

export type GetAllComModulesData = {
    path: {
        customerId: string;
    };
    query?: {
        deviceTypeId?: string;
        filter?: string;
        firmwareVersion?: string;
        /**
         * match all ComModules without associated labels. Only respected if true
         */
        hasNoLabel?: string;
        labels?: Array<(string)>;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
        systemTypeId?: string;
        tariffId?: string;
    };
};

export type GetAllComModulesResponse = (PageComModuleResponse);

export type GetAllComModulesError = (ErrorResponse);

export type UpdateDesiredModemOnSingleDeviceData = {
    body: DesiredFirmwareVersionRequest;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type UpdateDesiredModemOnSingleDeviceResponse = (void);

export type UpdateDesiredModemOnSingleDeviceError = (ErrorResponse);

export type UpdateDesiredModemOnAllDevicesData = {
    body: DesiredFirmwareVersionRequest;
    path: {
        customerId: string;
    };
};

export type UpdateDesiredModemOnAllDevicesResponse = (void);

export type UpdateDesiredModemOnAllDevicesError = (ErrorResponse);

export type UpdateDesiredFirmwareOnSingleDeviceData = {
    body: DesiredFirmwareVersionRequest;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type UpdateDesiredFirmwareOnSingleDeviceResponse = (void);

export type UpdateDesiredFirmwareOnSingleDeviceError = (ErrorResponse);

export type ResetDesiredFirmwareOnSingleDeviceData = {
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type ResetDesiredFirmwareOnSingleDeviceResponse = (void);

export type ResetDesiredFirmwareOnSingleDeviceError = (ErrorResponse);

export type UpdateDesiredFirmwareOnAllDevicesData = {
    body: DesiredFirmwareVersionRequest;
    path: {
        customerId: string;
    };
};

export type UpdateDesiredFirmwareOnAllDevicesResponse = (void);

export type UpdateDesiredFirmwareOnAllDevicesError = (ErrorResponse);

export type ResetDesiredFirmwareOnAllDevicesData = {
    path: {
        customerId: string;
    };
};

export type ResetDesiredFirmwareOnAllDevicesResponse = (void);

export type ResetDesiredFirmwareOnAllDevicesError = (ErrorResponse);

export type GetCloudAdapterByIdData = {
    path: {
        cloudAdapterConfigId: string;
        customerId: string;
    };
};

export type GetCloudAdapterByIdResponse = ((HttpCloudAdapterConfigDetailResponse | MqttCloudAdapterConfigDetailResponse));

export type GetCloudAdapterByIdError = (ErrorResponse);

export type UpdateCloudAdapterByIdData = {
    body: (UpdateHttpCloudAdapterConfigRequest | UpdateMqttCloudAdapterConfigRequest);
    path: {
        cloudAdapterConfigId: string;
        customerId: string;
    };
};

export type UpdateCloudAdapterByIdResponse = ((HttpCloudAdapterConfigDetailResponse | MqttCloudAdapterConfigDetailResponse));

export type UpdateCloudAdapterByIdError = (ErrorResponse);

export type DeleteCloudAdapterByIdData = {
    path: {
        cloudAdapterConfigId: string;
        customerId: string;
    };
};

export type DeleteCloudAdapterByIdResponse = (void);

export type DeleteCloudAdapterByIdError = (ErrorResponse);

export type GetAllCloudAdaptersData = {
    path: {
        customerId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllCloudAdaptersResponse = (PageCloudAdapterConfigResponse);

export type GetAllCloudAdaptersError = (ErrorResponse);

export type CreateCloudAdapterData = {
    body: (CreateHttpCloudAdapterConfigRequest | CreateMqttCloudAdapterConfigRequest);
    path: {
        customerId: string;
    };
};

export type CreateCloudAdapterResponse = ((HttpCloudAdapterConfigDetailResponse | MqttCloudAdapterConfigDetailResponse));

export type CreateCloudAdapterError = (ErrorResponse);

export type GetAssetByIdData = {
    path: {
        customerId: string;
        systemId: string;
    };
};

export type GetAssetByIdResponse = (SystemResponse);

export type GetAssetByIdError = (ErrorResponse);

export type UpdateAssetByIdData = {
    body: UpdateSystemRequest;
    path: {
        customerId: string;
        systemId: string;
    };
};

export type UpdateAssetByIdResponse = (SystemResponse);

export type UpdateAssetByIdError = (ErrorResponse);

export type DeleteAssetByIdData = {
    path: {
        customerId: string;
        systemId: string;
    };
};

export type DeleteAssetByIdResponse = (void);

export type DeleteAssetByIdError = (ErrorResponse);

export type BulkEditLabelsOnAssetsData = {
    body: BulkEditLabelsRequest;
    path: {
        customerId: string;
    };
};

export type BulkEditLabelsOnAssetsResponse = (Unit);

export type BulkEditLabelsOnAssetsError = (ErrorResponse);

export type GetAllAssetsData = {
    path: {
        customerId: string;
    };
    query: {
        filter?: string;
        /**
         * match all Systems without associated labels. Only respected if true
         */
        hasNoLabel?: string;
        labels?: Array<(string)>;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        pageable: Pageable;
        state?: State;
        systemTypeId?: string;
        tariffId?: string;
    };
};

export type GetAllAssetsResponse = (PageSystemResponse);

export type GetAllAssetsError = (ErrorResponse);

export type CreateAssetData = {
    body: CreateSystemRequest;
    path: {
        customerId: string;
    };
};

export type CreateAssetResponse = (SystemResponse);

export type CreateAssetError = (ErrorResponse);

export type GetAssetProfileByIdData = {
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type GetAssetProfileByIdResponse = (SystemTypeDetailResponse);

export type GetAssetProfileByIdError = (ErrorResponse);

export type UpdateAssetProfileByIdData = {
    body: SystemTypeRequest;
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type UpdateAssetProfileByIdResponse = (SystemTypeDetailResponse);

export type UpdateAssetProfileByIdError = (ErrorResponse);

export type DeleteAssetProfileByIdData = {
    path: {
        customerId: string;
        systemTypeId: string;
    };
};

export type DeleteAssetProfileByIdResponse = (void);

export type DeleteAssetProfileByIdError = (ErrorResponse);

export type GetAllAssetProfilesData = {
    path: {
        customerId: string;
    };
    query: {
        deviceTypeId?: string;
        filter?: string;
        /**
         * If tariffId is set, the lessThanTariffId will not be respected
         */
        lessThanTariffId?: string;
        pageable: Pageable;
        rtuEnabled?: boolean;
        tariffId?: string;
        tcpEnabled?: boolean;
    };
};

export type GetAllAssetProfilesResponse = (PageSystemTypeDetailResponse);

export type GetAllAssetProfilesError = (ErrorResponse);

export type CreateAssetProfileData = {
    body: SystemTypeRequest;
    path: {
        customerId: string;
    };
};

export type CreateAssetProfileResponse = (SystemTypeDetailResponse);

export type CreateAssetProfileError = (ErrorResponse);

export type ChangeCellularPriorityData = {
    body: UpdateCellularPriorityCommandRequest;
};

export type ChangeCellularPriorityResponse = (CommandRequestDataResponse);

export type ChangeCellularPriorityError = (ErrorResponse);

export type SetDesiredFirmwareAndStartFotaData = {
    body: DesiredFirmwareRequest;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type SetDesiredFirmwareAndStartFotaResponse = (FirmwareInformationResponse);

export type SetDesiredFirmwareAndStartFotaError = (ErrorResponse);

export type StartFotaForGivenIccidData = {
    body: StartFirmwareDownloadRequestV2;
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type StartFotaForGivenIccidResponse = (FirmwareInformationResponse);

export type StartFotaForGivenIccidError = (ErrorResponse);

export type GetFotaStatusData = {
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type GetFotaStatusResponse = (FirmwareInformationResponse);

export type GetFotaStatusError = (ErrorResponse);

export type CreateUserData = {
    body: CreateUserRequest;
};

export type CreateUserResponse = (UserResponse);

export type CreateUserError = (ErrorResponse);

export type ResetPasswordResponse = (void);

export type ResetPasswordError = (ErrorResponse);

export type GetUserByIdData = {
    path: {
        userId: string;
    };
};

export type GetUserByIdResponse = (UserResponse);

export type GetUserByIdError = (ErrorResponse);

export type DeleteUserByIdData = {
    path: {
        userId: string;
    };
};

export type DeleteUserByIdResponse = (void);

export type DeleteUserByIdError = (ErrorResponse);

export type UpdateUserByIdData = {
    body: UpdateUserRequest;
    path: {
        userId: string;
    };
};

export type UpdateUserByIdResponse = (UserResponse);

export type UpdateUserByIdError = (ErrorResponse);

export type GetLoggedInUserInfoResponse = (UserResponse);

export type GetLoggedInUserInfoError = (ErrorResponse);

export type GetAllCustomersData = {
    path: {
        tenantId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllCustomersResponse = (PageCustomerResponse);

export type GetAllCustomersError = (ErrorResponse);

export type CreateCustomerData = {
    body: CreateCustomerRequest;
    path: {
        tenantId: string;
    };
};

export type CreateCustomerResponse = (CustomerDetailResponse);

export type CreateCustomerError = (ErrorResponse);

export type GetCustomerByIdData = {
    path: {
        customerId: string;
        tenantId: string;
    };
};

export type GetCustomerByIdResponse = (CustomerDetailResponse);

export type GetCustomerByIdError = (ErrorResponse);

export type DeleteCustomerByIdData = {
    path: {
        customerId: string;
        tenantId: string;
    };
};

export type DeleteCustomerByIdResponse = (Unit);

export type DeleteCustomerByIdError = (ErrorResponse);

export type UpdateCustomerByIdData = {
    body: UpdateCustomerRequest;
    path: {
        customerId: string;
        tenantId: string;
    };
};

export type UpdateCustomerByIdResponse = (CustomerDetailResponse);

export type UpdateCustomerByIdError = (ErrorResponse);

export type InsertComModulesByTsvData = {
    body: {
        file?: (Blob | File);
    };
    path: {
        tenantId: string;
    };
};

export type InsertComModulesByTsvResponse = (Unit);

export type InsertComModulesByTsvError = (ErrorResponse);

export type EnableComModulesProtocolExtensionData = {
    body: {
        file?: (Blob | File);
    };
    path: {
        tenantId: string;
    };
};

export type EnableComModulesProtocolExtensionResponse = (Unit);

export type EnableComModulesProtocolExtensionError = (ErrorResponse);

export type GetAllCustomers1Data = {
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllCustomers1Response = (PageCustomerResponse);

export type GetAllCustomers1Error = (ErrorResponse);

export type CreateCustomer1Data = {
    body: CreateCustomerRequest;
};

export type CreateCustomer1Response = (CustomerDetailResponse);

export type CreateCustomer1Error = (ErrorResponse);

export type GetCustomerById1Data = {
    path: {
        customerId: string;
    };
};

export type GetCustomerById1Response = (CustomerDetailResponse);

export type GetCustomerById1Error = (ErrorResponse);

export type DeleteCustomerById1Data = {
    path: {
        customerId: string;
    };
};

export type DeleteCustomerById1Response = (Unit);

export type DeleteCustomerById1Error = (ErrorResponse);

export type UpdateCustomerById1Data = {
    body: UpdateCustomerRequest;
    path: {
        customerId: string;
    };
};

export type UpdateCustomerById1Response = (CustomerDetailResponse);

export type UpdateCustomerById1Error = (ErrorResponse);

export type ResetCustomerData = {
    path: {
        customerId: string;
    };
};

export type ResetCustomerResponse = (Unit);

export type ResetCustomerError = (ErrorResponse);

export type TestNewAdapterData = {
    body: CreateMqttCloudAdapterConfigRequest;
    path: {
        customerId: string;
    };
};

export type TestNewAdapterResponse = (TestRunResultResponse);

export type TestNewAdapterError = (ErrorResponse);

export type TestOnExistingAdapterData = {
    body: UpdateMqttCloudAdapterConfigRequest;
    path: {
        cloudAdapterConfigId: string;
        customerId: string;
    };
};

export type TestOnExistingAdapterResponse = (TestRunResultResponse);

export type TestOnExistingAdapterError = (ErrorResponse);

export type SingleWriteData = {
    body: SingleWriteRequest;
};

export type SingleWriteResponse = (CommandRequestDataResponse);

export type SingleWriteError = (ErrorResponse);

export type CreateRebootCommandData = {
    body: RebootRequest;
};

export type CreateRebootCommandResponse = (CommandRequestDataResponse);

export type CreateRebootCommandError = (ErrorResponse);

export type SingleReadData = {
    body: SingleReadRequest;
};

export type SingleReadResponse = (CommandRequestDataResponse);

export type SingleReadError = (ErrorResponse);

export type ClaimComModuleData = {
    body: CreateClaimRequest;
};

export type ClaimComModuleResponse = (ComModuleResponse);

export type ClaimComModuleError = (ErrorResponse);

export type GetComModuleByIccidAndSecretTagData = {
    path: {
        iccid: string;
    };
    query: {
        secretTag: string;
    };
};

export type GetComModuleByIccidAndSecretTagResponse = (ComModuleResponse);

export type GetComModuleByIccidAndSecretTagError = (ErrorResponse);

export type ResetComModuleData = {
    path: {
        comModuleId: string;
    };
};

export type ResetComModuleResponse = (void);

export type ResetComModuleError = (ErrorResponse);

export type GetTenantsData = {
    query?: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetTenantsResponse = (PageTenantResponse);

export type GetTenantsError = (ErrorResponse);

export type GetAllTenantUsersData = {
    path: {
        tenantId: string;
    };
    query?: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllTenantUsersResponse = (PageUserListResponse);

export type GetAllTenantUsersError = (ErrorResponse);

export type GetAllTenantRolesData = {
    path: {
        tenantId: string;
    };
};

export type GetAllTenantRolesResponse = (Array<RoleResponse>);

export type GetAllTenantRolesError = (ErrorResponse);

export type GetAllCustomerRolesData = {
    path: {
        customerId: string;
    };
};

export type GetAllCustomerRolesResponse = (Array<RoleResponse>);

export type GetAllCustomerRolesError = (ErrorResponse);

export type GetAllTokenScopesData = {
    path: {
        customerId: string;
    };
};

export type GetAllTokenScopesResponse = (Array<ScopeResponse>);

export type GetAllTokenScopesError = (ErrorResponse);

export type GetAllTokenRolesResponse = (Array<RoleResponse>);

export type GetAllTokenRolesError = (ErrorResponse);

export type GetReadoutErrorsData = {
    path: {
        systemId: string;
    };
    query?: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetReadoutErrorsResponse = (PageReadoutErrorResponse);

export type GetReadoutErrorsError = (ErrorResponse);

export type GetAllCustomerUsersData = {
    path: {
        customerId: string;
    };
    query?: {
        filter?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAllCustomerUsersResponse = (PageUserListResponse);

export type GetAllCustomerUsersError = (ErrorResponse);

export type GetDefaultValueData = {
    path: {
        customerId: string;
    };
};

export type GetDefaultValueResponse = (TemplateVariableCollection);

export type GetDefaultValueError = (ErrorResponse);

export type StreamComModuleDataData = {
    path: {
        comModuleId: string;
        customerId: string;
    };
};

export type StreamComModuleDataResponse = (SseEmitter);

export type StreamComModuleDataError = (ErrorResponse);

export type GetAuditEntriesData = {
    path: {
        customerId: string;
    };
    query?: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<(string)>;
    };
};

export type GetAuditEntriesResponse = (PageAuditEntryResponse);

export type GetAuditEntriesError = (ErrorResponse);

export type LoadWriteCommandInformationData = {
    path: {
        commandId: string;
    };
};

export type LoadWriteCommandInformationResponse = (CommandRequestDataResponse);

export type LoadWriteCommandInformationError = (ErrorResponse);

export type LoadRebootCommandInformationData = {
    path: {
        commandId: string;
    };
};

export type LoadRebootCommandInformationResponse = (CommandRequestDataResponse);

export type LoadRebootCommandInformationError = (ErrorResponse);

export type LoadReadCommandInformationData = {
    path: {
        commandId: string;
    };
};

export type LoadReadCommandInformationResponse = (CommandRequestDataResponse);

export type LoadReadCommandInformationError = (ErrorResponse);

export type LoadCellularCommandInformationData = {
    path: {
        commandId: string;
    };
};

export type LoadCellularCommandInformationResponse = (CommandRequestDataResponse);

export type LoadCellularCommandInformationError = (ErrorResponse);

export type VersionInfoResponse = ({
    [key: string]: (string);
});

export type VersionInfoError = (ErrorResponse);
